export const timezones = [
    { value: "America/Anchorage", label: "Alaska | Alaska Time (AKT) | America/Anchorage | UTC−09:00" },
    { value: "America/Phoenix", label: "Arizona (no DST) | Mountain Standard Time | America/Phoenix | UTC−07:00" },
    { value: "America/Chicago", label: "Central | Central Time (CT) | America/Chicago | UTC−06:00" },
    { value: "America/New_York", label: "East | Eastern Time (ET) | America/New_York | UTC−05:00" },
    { value: "Pacific/Honolulu", label: "Hawaii-Aleutian | Hawaii Time (HAT) | Pacific/Honolulu | UTC−10:00" },
    { value: "America/Indiana/Indianapolis", label: "Indiana (East) | Eastern Time | America/Indiana/Indianapolis | UTC−05:00" },
    { value: "America/Denver", label: "Mountain | Mountain Time (MT) | America/Denver | UTC−07:00" },
    { value: "America/Los_Angeles", label: "Pacific | Pacific Time (PT) | America/Los_Angeles | UTC−08:00" },
  ];
  